import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import LoadingState from "./LoadingState";

export function ProtectedRoute({ children, requireSuperAdmin, requireAdmin }) {
    const { user, loading, refreshMe, isSuperAdmin, canAdmin } = useAuth();
    const location = useLocation();

    useEffect(() => {
        if (!user && loading) {
            refreshMe();
        }
    }, [user, loading, refreshMe]);

    if (loading && !user) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#F5F7FB]">
                <LoadingState label="Verifica sessione…" />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requireSuperAdmin && !isSuperAdmin()) {
        return <Navigate to="/dashboard" replace />;
    }
    if (requireAdmin && !canAdmin()) {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
}

export default ProtectedRoute;
